import React from 'react'

const SchemeInfoPop = () => {
  return (
    <div>
      
    </div>
  )
}

export default SchemeInfoPop
